import React from 'react';

import { operators, concatOperators, nullOperators } from '../../../constants/filter';
import { getOperatorText } from '../../../utils/filter';
import CompoundExecutionStepFilterFieldValues from '../../../containers/compound/execution/StepFilterFieldValues';

const concatOperatorsText = {
  [concatOperators.AND]: 'AND',
  [concatOperators.OR]: 'OR',
};

const getConcatOperatorText = (concatOperator) => concatOperatorsText[concatOperator];

const CompoundExecutionStepFilterDetails = ({ filter, event, getFieldLabel }) => (
  <div style={{ borderTop: '1px solid #999', paddingTop: 10 }}>
    <div>Operator: {getConcatOperatorText(filter.concatOperator)}</div>
    {filter.clauses.map((clause) => (
      <div
        key={clause.field + clause.operator}
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          marginTop: 5,
        }}
      >
        <div>
          <strong>{getFieldLabel(clause.field)}</strong>
        </div>
        <div style={{ margin: '0px 5px', whiteSpace: 'nowrap' }}>
          {getOperatorText(clause.operator || operators['='])}
        </div>
        {!nullOperators.includes(clause.operator) && (
          <CompoundExecutionStepFilterFieldValues
            event={event}
            field={clause.field}
            value={clause.value}
          />
        )}
      </div>
    ))}
  </div>
);

export default CompoundExecutionStepFilterDetails;
